import axios from "axios";
import store from "../Redux/Store";
import { toast } from "react-toastify";
const axiosInstance = axios.create({
  headers: {
    "Content-Type": "application/json",
  },
});

// REQUEST INTERCEPTOR

axiosInstance.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem("loggedInUser");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      delete config.headers.Authorization;
    }
    const { appType } = store.getState().uiReducers;
    const localdb = "http://192.168.80.35:9090/api";
    const UATDb = "https://propertydevapi.tantrash.in/api";
    if (appType === "Business") {
      config.baseURL = UATDb;
    } else if (appType === "Ecommerce") {
      config.baseURL = "http://192.168.80.35:5050/api";
    } else {
      config.baseURL = UATDb;
    }
    return config;
  },
  (error) => {
    console.log(error);
    return Promise.reject(error);
  },
);

// RESPONSE INTERCEPTOR
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle network errors
    if (!error.response) {
      toast.error("Network error! Please check your internet.", {
        toastId: "00",
      });
      return Promise.reject(error);
    }
    const status = error.response.status;
    const message = error.response.data?.message || "Something went wrong!";
    // Custom error handling
    if (status === 401) {
      toast.error("Unauthorized! Please login again.", {
        toastId: "01",
      });
    } else if (status === 403) {
      toast.error("Access denied!", {
        toastId: "02",
      });
    } else if (status === 404) {
      // toast.error("Resource not found!", {
      //   toastId: "03",
      // });
    } else if (status >= 500) {
      toast.error("Server error! Try again later.", {
        toastId: "04",
      });
    } else {
      toast.error(message);
    }
    return Promise.reject(error);
  },
);

export default axiosInstance;
